module.exports = __webpack_public_path__ + "static/process-b4b097b3f68fd1ec2d9f4bd3227597b4.svg";